import { useSaleOrderPendingPayment } from 'frontendMyOrders/hooks'
import { Link } from 'react-router-dom'

const PendingPaymentSaleOrders = () => {
  const { pendingPaymentOrders } = useSaleOrderPendingPayment()

  return (
    <div>
      <ul>
        {pendingPaymentOrders?.map(order => (
          <li key={order.id}>
            <Link to={`/${order.id}`}>Pedido {order.id}</Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default PendingPaymentSaleOrders
